export default "__VITE_ASSET__9b02d035__"